export const checkForEmptyField = (field: string): boolean => {
  return field === "" || field === null || field === undefined;
};
